import { ShopfloorLayoutSpecNode } from './shopfloor-layout-spec-node'
import { TransportCost } from './transport-cost'

export class ShopfloorLayoutSpecEdge {
  private static buildId(source: string, target: string): string {
    return source.substring(10, source.length) + '-' + target.substring(10, target.length)
  }

  public static build(
    source: ShopfloorLayoutSpecNode,
    target: ShopfloorLayoutSpecNode,
    transportCost: TransportCost
  ): ShopfloorLayoutSpecEdge {
    const id = this.buildId(source.id, target.id)
    return new ShopfloorLayoutSpecEdge(id, source.id, target.id, transportCost)
  }

  constructor(
    public id: string,
    public source: string,
    public target: string,
    public transportCost: TransportCost
  ) {}
}
